<template>
  <section id="why-ssl" :class="{ 'brand-section--muted': isMuted }">
    <div class="inner-bound pt50 pb60">
      <h2 class="text-section-title" v-animate="'fadeInUp'">
        {{ title }}
      </h2>
      <p class="text-section-desc" v-animate="'fadeInUp'" v-if="desc">
        {{ desc }}
      </p>

      <div class="ssl-why-grid" :style="{ 'grid-template-columns': `repeat(${columns}, 1fr)` }">
        <div
          v-for="(item, index) in items"
          :key="item.title"
          :class="['ssl-why-card', { 'base-card': border }]"
          v-animate="'fadeInUp'"
          :style="{ 'background-color': isMuted && !border ? '#f5f8ff' : '#fff' }"
        >
          <div class="ssl-why-icon" v-if="icons.length > 0 || item.icon">
            <img :src="icons.length > 0 ? icons[index] : item.icon" :alt="item.title" />
          </div>
          <div :class="[needCylinder ? 'ssl-why-title' : 'ssl-why-title-nocylinder']">
            <h3>{{ item.title }}</h3>
          </div>
          <!-- <p class="ssl-why-desc">{{ item.desc }}</p> -->
          <p class="ssl-why-desc" v-html="item.desc"></p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
const { t, tm, rt, locale } = useI18n()

const props = defineProps({
  title: { type: String, default: '' },
  items: { type: Array, default: () => [] },
  isMuted: { type: Boolean, default: false },
  desc: { type: String, default: '' },
  columns: { type: Number, default: 3 },
  icons: { type: Array, default: () => [] },
  border: { type: Boolean, default: false },
  needCylinder: { type: Boolean, default: true }
})
</script>
